export default __webpack_public_path__ + "static/media/droplet-set-orange@3x.ee53786f.png";